import {
  Image,
  Title,
  Typography,
  TypographyWithLabel,
  Button
} from '@jeromevvb/equinox-lib'
import styles from './styles'

import { NFT_URLS } from '@config/marketplace'

import Autumnal from '@public/nft/autumnal.jpg'
import Winter from '@public/nft/winter.jpg'
import Vernal from '@public/nft/vernal.jpg'
import Summer from '@public/nft/summer.jpg'

const NFTs = [
  {
    name: 'Autumnal',
    artwork: Autumnal,
    ido: 'Lottery/FCFS',
    ino: 'Lottery',
    url: NFT_URLS['autumnal']
  },
  {
    name: 'Winter',
    artwork: Winter,
    ido: 'Lottery/FCFS',
    ino: 'Lottery',
    url: NFT_URLS['winter']
  },
  {
    name: 'Vernal',
    artwork: Vernal,
    ido: 'Lottery/FCFS',
    ino: 'Lottery',
    url: NFT_URLS['vernal']
  },
  {
    name: 'Summer',
    artwork: Summer,
    ido: 'Guaranteed allocation',
    ino: 'Lottery',
    url: NFT_URLS['summer']
  }
]

const NftInfoTable = () => (
  <div css={styles}>
    <div className="nft-table">
      <div className="row">
        <div className="column key">
          <Title size="medium" weight="semibold">
            NFT
          </Title>
        </div>
        <div className="values">
          {NFTs.map(({ name, artwork }, key) => (
            <div key={key} className="column">
              <Title size="medium" weight="semibold" className="mb-4">
                {name}
              </Title>
              <Image src={artwork.src} alt={name} className="artwork" />
            </div>
          ))}
        </div>
      </div>
      <div className="row">
        <div className="column key">
          <Title size="medium" weight="semibold">
            IDO
          </Title>
        </div>
        <div className="values">
          {NFTs.map(({ ido }, key) => (
            <div key={key} className="column">
              <Typography>{ido}</Typography>
            </div>
          ))}
        </div>
      </div>
      <div className="row">
        <div className="column key">
          <Title size="medium" weight="semibold">
            INO
          </Title>
        </div>
        <div className="values">
          {NFTs.map(({ ino }, key) => (
            <div key={key} className="column">
              <Typography>{ino}</Typography>
            </div>
          ))}
        </div>
      </div>
      <div className="row">
        <div className="column key" />
        <div className="values">
          {NFTs.map(({ url, name }, key) => (
            <div key={key} className="column">
              <a
                href={url}
                target="_blank"
                rel="noreferrer noopener"
                className="inline-block mx-auto"
              >
                <Button variant="contained" size="large" color="primary">
                  Buy now
                </Button>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>

    <div className="nft-cards">
      {NFTs.map(({ name, artwork, ido, ino, url }, key) => (
        <div key={key} className="card">
          <h4 className="card-name">{name}</h4>
          <Image src={artwork.src} alt={name} className="artwork" />
          <TypographyWithLabel
            label="IDO"
            direction="column"
            className="card-value"
            TypographyLabelProps={{
              color: 'secondary',
              weight: 'semibold',
              className: 'card-label'
            }}
          >
            {ido}
          </TypographyWithLabel>
          <TypographyWithLabel
            label="INO"
            direction="column"
            className="card-value"
            TypographyLabelProps={{
              color: 'secondary',
              weight: 'semibold',
              className: 'card-label'
            }}
          >
            {ino}
          </TypographyWithLabel>
          <div className="card-cta">
            <a href={url} className="inline-block mx-auto">
              <Button variant="contained" color="primary">
                Buy now
              </Button>
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>
)

export default NftInfoTable
